var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Download(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C10.4142 1 10.75 1.33579 10.75 1.75V10.537L12.7413 8.6989C13.0457 8.41794 13.5202 8.43692 13.8011 8.74129C14.0821 9.04566 14.0631 9.52015 13.7587 9.8011L10.5087 12.8011C10.2214 13.0663 9.77859 13.0663 9.49129 12.8011L6.24129 9.8011C5.93692 9.52015 5.91794 9.04566 6.1989 8.74129C6.47985 8.43692 6.95434 8.41794 7.25871 8.6989L9.25 10.537V1.75C9.25 1.33579 9.58579 1 10 1ZM1.75 13C2.16421 13 2.5 13.3358 2.5 13.75V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V13.75C17.5 13.3358 17.8358 13 18.25 13C18.6642 13 19 13.3358 19 13.75V16.25C19 17.7688 17.7688 19 16.25 19H3.75C2.23122 19 1 17.7688 1 16.25V13.75C1 13.3358 1.33579 13 1.75 13Z",
    fill: "#182BCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Download);
export default __webpack_public_path__ + "static/media/20-download.f627ba97ae2e0d5bce3352582800d2b3.svg";
export { ForwardRef as ReactComponent };